const ja = {
  // Nav
  nav_home: 'ホーム',
  nav_products: '製品',
  nav_about: '会社概要',
  nav_contact: 'お問い合わせ',
  nav_explore: '探す',

  // Hero
  hero_badge: '猫用爪とぎ · プロフェッショナル品質',
  hero_title1: '猫と共に生きる',
  hero_title2: '爪とぎ一つひとつが',
  hero_title3: '喜びの儀式',
  hero_desc: '厳選された天然素材と人間工学に基づいたデザインで、猫が爪とぎを愛し、お家をもっと美しく。Koorpetは、すべての肉球の幸せを守ります。',
  hero_btn_products: '製品を見る',
  hero_btn_about: 'ブランドストーリー',
  hero_stat1_num: '6+',
  hero_stat1_label: '年の業界経験',
  hero_stat2_num: '50+',
  hero_stat2_label: '製品ライン',
  hero_stat3_num: '10万+',
  hero_stat3_label: '猫が信頼',
  hero_scroll: 'スクロール',

  // Featured Products
  featured_label: 'おすすめ製品',
  featured_title: '人気製品',
  featured_subtitle: '猫に一番人気のコレクション',
  featured_view_all: '全製品を見る',
  featured_empty: 'まだおすすめ製品はありません',

  // Features Section
  features_badge: 'コアな強み',
  features_title: 'Koorpetを選ぶ理由',
  features_desc: 'すべての製品は厳格な研究開発テストを経て、猫に最高の爪とぎ体験を提供します',
  feature1_title: '三層高密度プレス',
  feature1_desc: '高品質の段ボールに三層熱プレス技術を採用し、通常品の2倍の密度で、より耐久性があり長持ちします。',
  feature2_title: '天然キャットニップ配合',
  feature2_desc: 'オーガニックキャットニップを段ボール層に均一に配合し、持続的な天然の香りで猫を引き付けます。',
  feature3_title: '無毒エコ認証',
  feature3_desc: 'すべての原材料が国家環境検査に合格。ホルムアルデヒドフリー、重金属フリーで、猫が噛んでも安全です。',
  feature4_title: '人間工学デザイン',
  feature4_desc: '猫の爪とぎ行動学の研究に基づき、角度と高さを最適化し、猫の自然な爪とぎ姿勢に完璧にフィットします。',

  // Brand Section
  brand_label: '職人のこだわり',
  brand_title1: '職人のこだわり',
  brand_title2: '最高の猫用爪とぎのために',
  brand_desc: 'Koorpetは2024年に設立され、中国で猫用爪とぎの研究開発と生産に特化したリーディングブランドです。工場面積は4,000平方メートル、完全自動化生産ラインを備え、年間生産能力は200万個です。良い爪とぎは家具を保護するだけでなく、猫の生活の質を向上させると私たちは信じています。',
  brand_years_num: '2024',
  brand_years_label: '設立年',
  brand_years_desc: '4,000㎡の最新工場と完全自動化生産ラインで、世界中の猫家族に高品質な爪とぎ製品を継続的に提供しています。',
  brand_cert1_label: '国家品質認証',
  brand_cert1_sub: 'ISO 9001認証',
  brand_cert2_label: '天然エコ素材',
  brand_cert2_sub: '無毒認証',
  brand_cert3_label: '10カ国以上に輸出',
  brand_cert3_sub: '国際品質基準',
  brand_cert4_label: '10万匹以上の猫',
  brand_cert4_sub: '信頼の選択',
  brand_cta: '',

  // CTA Section
  cta_quote_label: '猫の飼い主の声',
  cta_quote: '"Koorpetを使い始めてから、やっとソファが守られました！"',
  cta_label: '今すぐ行動',
  cta_title1: '猫に愛される',
  cta_title2: '自分だけの場所を',
  cta_desc: '10万匹以上の猫がKoorpetを選んでいます。天然素材、考え抜かれたデザイン、厳格な品質管理 — すべての製品が猫への最高のギフトです。今すぐ注文して、品質ある生活を。',
  cta_btn: '今すぐ購入',

  // Reviews Section
  reviews_title: '実際の飼い主の声：',
  reviews_subtitle: '全国各地の猫の飼い主からのリアルなレビュー',
  review1_name: '茶トラ猫ママ',
  review1_content: 'クラウドシリーズを買いました！うちの茶トラ猫は初日から虜になりました。品質が素晴らしく、段ボールは厚くて丈夫、キャットニップの香りが猫を夢中にさせます。強くおすすめします！',
  review1_product: 'クラウドシリーズ猫用爪とぎ',
  review2_name: 'ラグドールの飼い主',
  review2_content: 'サイザル麻の爪とぎポストは細工が丁寧で、サイザルロープの巻きがしっかりしていて、ベースは非常に安定しています。うちのラグドールは毎日そこで爪を研いでいて、やっとソファが守られました！',
  review2_product: 'サイザル麻猫用爪とぎポスト',
  review3_name: '三毛猫の飼い主',
  review3_content: 'ウェーブ爪とぎボードのデザインは賢く、裏返して使えるので寿命が2倍、コスパ抜群。猫はその上で寝るのも大好きで、一石二鳥です！',
  review3_product: 'ウェーブ猫用爪とぎボード',
  review4_name: 'ブリティッシュショートヘアのパパ',
  review4_content: '梱包がとても丁寧で、製品の品質は文句なし。カスタマーサービスも素早く対応してくれます。すでに3回リピート購入しました、うちの猫の一番好きなブランドです！',
  review4_product: 'キャットニップ丸型猫用爪とぎ',

  // About Banner
  about_breadcrumb_home: 'ホーム',
  about_breadcrumb_about: '会社概要',
  about_banner_title: 'Koorpetについて',
  about_banner_desc: '職人品質、すべての猫の幸せな生活のために。良い製品が人とペットの絆をより美しくすると信じています。',

  // Company Stats
  stat1_num: '2024',
  stat1_label: '設立',
  stat1_sub: 'ペット業界に深く根ざす',
  stat2_num: '50+',
  stat2_label: '製品',
  stat2_sub: '猫のあらゆるシーンをカバー',
  stat3_num: '10万+',
  stat3_label: '匹の猫',
  stat3_sub: 'Koorpetを信頼',
  stat4_num: '30+',
  stat4_label: '特許',
  stat4_sub: '継続的な革新',

  // Brand Story
  story_label: 'ブランドストーリー',
  story_float_num: '2024年',
  story_float_desc: '猫用爪とぎ分野に深く根ざし、品質と革新に注力',
  story_title1: '一つの猫用爪とぎから',
  story_title2: 'ブランドの誕生へ',
  story_p1: '2024年に設立されたKoorpetは、中国で猫用爪とぎの研究開発と生産に特化したリーディングブランドです。4,000平方メートルの最新工場で、完全自動化生産ラインを稼働し、年間生産能力は200万個です。',
  story_p2: 'ペット業界での長年の経験から、創業者は市場に真に品質とユーザー体験デザインを追求する製品が不足していることを認識しました。Koorpetを創る決意をし、より高い基準で猫用爪とぎを再定義しました。',
  story_p3: '原材料の選定から完成品まで、すべての工程が厳格な品質管理を受けています。「天然素材、考え抜かれたデザイン、厳格な品質管理」の理念を貫き、すべての猫に最高の爪とぎ体験を提供することに専念しています。今日、Koorpetは信頼される猫用爪とぎブランドとなり、製品は多くの国と地域で販売されています。',
  story_founder_name: 'John Yu',
  story_founder_role: 'Koorpet 創業者',
  story_founder_quote: '"私たちは単に猫用爪とぎを作っているのではなく、すべての猫家族のためにより良い共生空間を創造しています。"',

  // Timeline
  timeline_label: '沿革',
  timeline_title: '私たちの歩み',
  timeline_desc: 'OEM製造から自社ブランドへ、一歩一歩着実に。これがKoorpetの成長の足跡です。',
  milestone1_title: 'OEM事業開始',
  milestone1_desc: '国際的なペットブランド向けに猫用爪とぎのOEM製造サービスを開始し、サプライチェーンの基盤を確立し、生産技術と品質管理の経験を蓄積しました。',
  milestone2_title: '工場拡張',
  milestone2_desc: '4,000㎡の最新工場を拡張し、完全自動化生産ラインを導入、年間生産能力は500万個に達しました。',
  milestone3_title: '輸出の躍進',
  milestone3_desc: 'OEM製品が10カ国以上に輸出され、50以上の海外クライアントにサービスを提供し、品質が国際的に認められました。',
  milestone4_title: 'ブランド準備',
  milestone4_desc: '独立した研究開発チームを結成し、自社ブランドKoorpetを準備、最初のオリジナル製品デザインと特許レイアウトを完了しました。',
  milestone5_title: 'Koorpet 設立',
  milestone5_desc: 'Koorpetブランドが正式に設立され、初の高密度段ボール猫用爪とぎシリーズが発売され、市場で大きな反響を得ました。',
  milestone6_title: '製品ライン拡大',
  milestone6_desc: 'サイザル麻の爪とぎポスト、キャットタワーシリーズなどの新製品を発売し、ISO 9001などの国際認証を取得、ブランドの影響力が拡大し続けています。',
  milestone7_title: 'ユーザーマイルストーン',
  milestone7_desc: '10万以上の猫家族にサービスを提供し、Koorpetは中国の猫用爪とぎカテゴリーのリーディングブランドとなり、業界をリードし続けています。',

  // Team Section
  team_label: 'コアチーム',
  team_title: 'コアチーム',
  team_desc: '本当に猫を愛する人々が、専門性と情熱で一つひとつの製品を作り上げています',
  team_more: 'さらに',
  team_more2: '名の情熱的なKoorpetプロフェッショナルメンバー',
  team1_name: 'John Yu',
  team1_role: '創業者',
  team1_desc: '業界トップ企業でチャネル責任者を務め、ペット用品市場に深い洞察を持つ。猫の福祉への深い理解と製品品質への妥協なき追求に基づき、2024年にKoorpetを創業。チームをOEM製造から自社ブランドへと導き、ゼロからイチへの突破を実現。',
  team1_tag1: 'ブランド創業',
  team1_tag2: 'チャネル拡大',
  team2_name: '林 暁雯',
  team2_role: 'チーフデザイナー',
  team2_desc: '中央美術学院工業デザイン学科卒業。ペット製品デザインに8年従事し、Koorpetの30以上の製品の外観デザインを主導。',
  team2_tag1: '製品デザイン',
  team2_tag2: 'ユーザー体験',
  team3_name: '王 建国',
  team3_role: '研究開発ディレクター',
  team3_desc: '材料工学博士。ペット用品材料の研究開発に10年従事し、Koorpetの低粉塵配合とキャットニップ注入プロセスの開発を主導。',
  team3_tag1: '材料研究開発',
  team3_tag2: 'プロセス革新',
  team4_name: '張 美玲',
  team4_role: '品質ディレクター',
  team4_desc: 'ISO品質マネジメントシステム認証資格を保有。Koorpet全製品ラインの品質管理を担当し、すべての製品が出荷基準を満たすことを保証。',
  team4_tag1: '品質管理',
  team4_tag2: 'ISO認証',

  // Certificates
  cert_label: '資格と栄誉',
  cert_title: '資格と認証',
  cert_desc: '数々の権威ある認証 — Koorpetの品質と革新の最高の証明',
  cert1_title: 'ISO 9001',
  cert1_sub: '品質マネジメントシステム認証',
  cert1_desc: '国際品質マネジメントシステム認証を取得。生産プロセスは完全に追跡可能で、品質が保証されています。',
  cert1_year: '2018年取得',
  cert2_title: 'エコ無毒認証',
  cert2_sub: '国家環境検査合格',
  cert2_desc: 'すべての原材料が国家環境検査に合格。ホルムアルデヒドフリー、重金属フリーで、猫が噛んでも安全です。',
  cert2_year: '2017年取得',
  cert3_title: 'ペット用品安全認証',
  cert3_sub: '中国ペット用品協会',
  cert3_desc: '中国ペット用品協会から安全認証を授与。業界内でこの認証を受けた数少ないブランドの一つです。',
  cert3_year: '2019年取得',
  cert4_title: 'CE 欧州認証',
  cert4_sub: 'EU市場アクセス',
  cert4_desc: 'EU CE認証を取得。製品はEUの安全、健康、環境基準に適合し、EU市場での販売が可能です。',
  cert4_year: '2020年取得',
  awards_title: '栄誉賞',
  award1_title: '年間ペット用品革新的デザイン賞',
  award1_org: '中国ペット産業博覧会',
  award2_title: '最も信頼される猫の飼い主ブランド',
  award2_org: 'ペットホーム年次選定',
  award3_title: '国家ハイテク企業認定',
  award3_org: '広東省科学技術庁',
  award4_title: '広東省著名商標',
  award4_org: '広東省工商行政管理局',
  award5_title: 'ペット用品輸出優良企業',
  award5_org: '広州市商務局',
  award6_title: '広州市優秀中小企業',
  award6_org: '広州市工業情報化局',

  // About CTA
  about_cta_label: '参加する',
  about_cta_title1: '一緒に猫のために',
  about_cta_title2: 'より良い生活を創造しよう',
  about_cta_btn1: '製品を探す',
  about_cta_btn2: 'お問い合わせ',

  // Products Banner
  products_breadcrumb_home: 'ホーム',
  products_breadcrumb: '製品',
  products_banner_title: '製品センター',
  products_banner_desc: '厳選された天然素材、丹念に作り上げられた猫用爪とぎ — 猫が爪とぎの儀式を愛するように',

  // Products CTA
  products_cta_title: '適切な製品が見つかりませんか？',
  products_cta_desc: 'お客様のニーズに合わせたカスタマイズソリューションについてお問い合わせください',
  products_cta_btn: 'お問い合わせ',

  // Product Filter
  filter_all: 'すべて',
  filter_count: '',
  filter_count2: '件の製品',
  sort_default: 'デフォルト',
  sort_price_asc: '価格：低い順',
  sort_price_desc: '価格：高い順',
  category_corrugated: '段ボール',
  category_sisal: 'サイザル麻',
  category_combo: 'コンボ',

  // Product Card
  product_view_detail: '詳細を見る',

  // Product Detail
  detail_product_code: '製品コード',
  detail_not_found: '製品が見つかりません',
  detail_back_to_products: '製品一覧に戻る',

  // Tags
  tag_hot_selling: '売れ筋',
  tag_new: '新着',
  tag_corrugated_paper: '段ボール',
  tag_limited_offer: '期間限定',
  tag_bestseller: 'ベストセラー',
  tag_recommended: 'おすすめ',
  tag_catnip: 'キャットニップ',
  tag_sisal: 'サイザル麻',
  tag_corner_protector: 'コーナープロテクター',
  tag_cat_tree: 'キャットタワー',
  tag_eco_friendly: 'エコ',

  detail_tab_desc: '製品詳細',
  detail_tab_specs: '仕様',
  detail_tab_faq: 'よくある質問',
  detail_spec_material: '素材',
  detail_spec_size: 'サイズ',
  detail_spec_weight: '重量',
  detail_spec_moq: '最小注文数',
  detail_spec_suitable: '対象猫',
  detail_spec_suitable_val: '全サイズ',
  detail_spec_package: 'パッケージ内容',
  detail_spec_package_val: '製品本体 × 1、説明書 × 1',

  detail_save: '',
  detail_save_unit: 'お得',
  detail_btn_consult: '購入相談',
  related_title: 'あなたにおすすめ',
  related_view_all: 'すべて見る',

  // Highlight Titles
  highlight_title_triple_layer: '三層プレス加工',
  highlight_title_catnip_infused: 'オーガニックキャットニップ配合',
  highlight_title_eco_certified: '無毒エコ認証',
  highlight_title_anti_slip: '滑り止め底面',
  highlight_title_natural_sisal: '天然サイザル麻',
  highlight_title_solid_wood: '無垢材ベース',
  highlight_title_golden_height: '最適な高さ60cm',
  highlight_title_nail_care: '自然な爪ケア',
  highlight_title_double_sided: '両面使用可能',
  highlight_title_wave_curve: '波形曲面デザイン',
  highlight_title_low_dust: '低粉塵フォーミュラ',
  highlight_title_rubber_strip: '滑り止めラバーストリップ',
  highlight_title_sofa_design: 'ソファ専用設計',
  highlight_title_tool_free: '工具不要',
  highlight_title_sofa_safe: 'ソファを傷つけない',
  highlight_title_set_of_4: '4個セット',
  highlight_title_catnip_builtin: 'キャットニップ内蔵',
  highlight_title_round_design: '円形美しいデザイン',
  highlight_title_safe_edge: '安全なエッジ処理',
  highlight_title_hot_seller: 'ベストセラー',
  highlight_title_three_level: '三段プラットフォーム',
  highlight_title_15kg_capacity: '15kg以上の耐荷重',
  highlight_title_hanging_toy: '吊り下げおもちゃ付き',
  highlight_title_wide_base: '広く安定したベース',

  // Highlight Descriptions
  highlight_desc_triple_layer: '通常品の2倍の密度で、より耐久性があります',
  highlight_desc_catnip_infused: '持続的な香りで、猫が自ら近づきます',
  highlight_desc_eco_certified: '噛んでも安全です',
  highlight_desc_anti_slip: '使用中にずれません',
  highlight_desc_natural_sisal: '手巻きで均一に巻かれ、丈夫です',
  highlight_desc_solid_wood: '防腐処理済みの松材で、安定して倒れません',
  highlight_desc_golden_height: '猫の背伸びニーズを満たします',
  highlight_desc_nail_care: '爪を効果的に整え、家具を保護します',
  highlight_desc_double_sided: '裏返して使い続けられ、寿命が2倍に',
  highlight_desc_wave_curve: '猫の自然な爪とぎ姿勢にフィット',
  highlight_desc_low_dust: '紙くずが少なく、家を清潔に保ちます',
  highlight_desc_sofa_design: 'ソファの角にぴったりフィットし、全方位保護',
  highlight_desc_tool_free: '強力マジックテープで30秒で設置',
  highlight_desc_sofa_safe: '裏面保護層で跡が残りません',
  highlight_desc_set_of_4: 'ソファの四隅を同時に保護',
  highlight_desc_catnip_builtin: '猫が爪とぎ板を使わない問題を解決',
  highlight_desc_round_design: '平置きも壁掛けも可能、一台二役',
  highlight_desc_safe_edge: 'バリがなく、猫に安全',
  highlight_desc_hot_seller: '月間5000個以上販売、高評価',
  highlight_desc_three_level: '猫の高所好きな本能を満たします',
  highlight_desc_15kg_capacity: '多頭飼いの家庭でも安心',
  highlight_desc_hanging_toy: '猫の遊び心を刺激します',
  highlight_desc_wide_base: 'ジャンプしても倒れません',

  // Additional Tags
  tag_double_sided: '両面使用',
  tag_sofa_protector: 'ソファ保護',
  tag_multi_function: '多機能',

  // Contact Banner
  contact_breadcrumb_home: 'ホーム',
  contact_breadcrumb: 'お問い合わせ',
  contact_banner_title: 'お問い合わせ',
  contact_banner_desc: '製品に関するご質問、ビジネス協力、アフターサービスなど、いつでもお気軽にご連絡ください',

  // Contact Form
  contact_form_label: 'メッセージを送信',
  contact_form_title: 'メッセージを残す',
  contact_form_desc: '以下のフォームにご記入ください。1営業日以内にご返信いたします',
  contact_form_success_title: 'メッセージ送信完了！',
  contact_form_success_desc: 'メッセージをありがとうございます。1営業日以内にご連絡いたします。',
  contact_form_success_btn: '再度送信',
  contact_form_name: 'お名前',
  contact_form_name_placeholder: 'お名前を入力してください',
  contact_form_phone: '電話番号',
  contact_form_phone_placeholder: '電話番号を入力してください',
  contact_form_email: 'メールアドレス',
  contact_form_email_placeholder: 'メールアドレスを入力してください',
  contact_form_inquiry: 'お問い合わせ種別',
  contact_form_company: '会社名',
  contact_form_company_optional: '（任意）',
  contact_form_company_placeholder: '該当する場合は会社名を入力してください',
  contact_form_message: 'メッセージ内容',
  contact_form_message_placeholder: 'ご要望やご質問を詳細にご記入ください...',
  contact_form_required: '*',
  contact_form_error: '送信に失敗しました。再度お試しください。',
  contact_form_sending: '送信中...',
  contact_form_submit: 'メッセージを送信',
  inquiry_type1: '製品について',
  inquiry_type2: '卸売協力',
  inquiry_type3: 'アフターサービス',
  inquiry_type4: 'メディア協力',
  inquiry_type5: 'その他',

  // Contact CTA
  contact_cta_title: 'その他のご質問は？',
  contact_cta_desc: 'よくある質問をご覧いただくか、直接メールでお問い合わせください',
  contact_cta_btn_browse: '製品を見る',
  contact_cta_btn_email: 'メールを送信',

  // Contact Info
  contact_info1_title: '会社住所',
  contact_info1_line1: 'FLAT /RM A 9/F SILVERCORP',
  contact_info1_line2: 'INTERNATIONAL TOWER 707-713 NATHAN ROAD MONGKOK HONGKONG',
  contact_info1_action: '地図を見る',
  contact_info2_title: 'カスタマーサービス',
  contact_info2_line1: 'カスタマーサービス',
  contact_info2_line2: '月〜金 9:00 - 18:00',
  contact_info2_action: 'チャット',
  contact_info3_title: 'メール',
  contact_info3_line1: 'cs@koorpet.com',
  contact_info3_line2: 'ビジネス：cs@koorpet.com',
  contact_info3_action: 'メール送信',
  contact_info4_title: 'WhatsApp',
  contact_info4_line1: 'Koorpet 公式',
  contact_info4_line2: 'WhatsAppで直接お問い合わせください',
  contact_info4_action: 'チャットを開始',

  // Footer
  footer_brand_desc: '猫用爪とぎの研究開発と生産に専念し、すべての猫に自分だけの幸せな場所を。',
  footer_nav_title: 'クイックリンク',
  footer_products_title: '製品ライン',
  footer_product1: '段ボール爪とぎ',
  footer_product2: 'サイザル麻爪とぎポスト',
  footer_product3: 'キャットタワーシリーズ',
  footer_product4: 'コーナープロテクター',
  footer_product5: 'キャットニップシリーズ',
  footer_contact_title: 'お問い合わせ',
  footer_address: 'FLAT /RM A 9/F SILVERCORP INTERNATIONAL TOWER 707-713 NATHAN ROAD MONGKOK HONGKONG',
  footer_phone: '月〜金 9:00 - 18:00',
  footer_whatsapp: 'WhatsApp',
  footer_email: 'cs@koorpet.com',
  footer_hours: '月〜金 9:00 - 18:00',
  footer_copyright: '© 2026 DANA INTERNATIONAL (HK) CO., LIMITED',
  footer_privacy: 'プライバシーポリシー',
  footer_terms: '利用規約',
  footer_admin: '管理画面',

  // Legal Page
  legal_breadcrumb: '法的情報',
  legal_banner_title: '法的情報',
  legal_banner_desc: 'お客様の権利をどのように保護するかを理解するために、以下の条項をよくお読みください',
  legal_updated: '最終更新',

  // Privacy Policy
  privacy_s1_title: '本ポリシーについて',
  privacy_s1_p1: 'DANA INTERNATIONAL (HK) CO., LIMITED（以下「Koorpet」または「当社」）は、ユーザーのプライバシー保護を非常に重視しています。本プライバシーポリシーは、当社がお客様の個人情報をどのように収集、使用、保存、保護するかについて説明します。',
  privacy_s1_p2: '当社のウェブサイト、製品、またはサービスを利用することにより、本プライバシーポリシーの条件に同意したものとみなされます。同意されない場合は、当社サービスの利用を中止してください。',
  privacy_s2_title: '収集する情報',
  privacy_s2_p1: 'より良いサービスを提供するために、当社は以下の種類の情報を収集する場合があります：',
  privacy_s2_li1: '身元情報：名前、電話番号、メールアドレス',
  privacy_s2_li2: '取引情報：注文履歴、配送先住所、支払い詳細',
  privacy_s2_li3: 'デバイス情報：IPアドレス、ブラウザの種類、オペレーティングシステム',
  privacy_s2_li4: '利用データ：ページ訪問記録、クリック行動、検索キーワード',
  privacy_s3_title: '情報の利用方法',
  privacy_s3_p1: '収集した情報は以下の目的で使用されます：',
  privacy_s3_li1: '注文の処理および関連するアフターサービスの提供',
  privacy_s3_li2: '製品アップデートやプロモーション通知の送信（いつでも配信停止可能）',
  privacy_s3_li3: 'ウェブサイトの機能とユーザー体験の向上',
  privacy_s4_title: '情報の共有と開示',
  privacy_s4_p1: '当社はお客様の個人情報を第三者に販売することはありません。以下の状況で情報を共有する場合があります：',
  privacy_s4_p2: '物流パートナーとの配送情報の共有、法令要件の遵守、お客様の明示的な許可がある場合。',
  privacy_s5_title: '情報セキュリティ',
  privacy_s5_p1: '当社は、SSL暗号化通信やデータアクセス制御など、業界標準のセキュリティ対策を使用してお客様の個人情報を保護しています。ただし、インターネット通信は絶対的に安全ではなく、情報伝送の絶対的な安全性を保証することはできません。',
  privacy_s6_title: 'お客様の権利',
  privacy_s6_p1: 'お客様はご自身の個人情報に関して以下の権利を有します：',
  privacy_s6_li1: 'アクセス権：当社が保有するお客様の個人情報にいつでもアクセスできます',
  privacy_s6_li2: '訂正権：情報が誤っている場合、訂正を要求できます',
  privacy_s6_li3: '削除権：特定の状況において、お客様の個人情報の削除を要求できます',
  privacy_s7_title: 'お問い合わせ',
  privacy_s7_p1: '本プライバシーポリシーについてご質問がある場合は、以下までお問い合わせください：',

  // Terms of Use
  terms_s1_title: '利用規約の承諾',
  terms_s1_p1: 'Koorpet公式ウェブサイトへようこそ。本ウェブサイトにアクセスまたは利用することにより、本利用規約に拘束されることに同意したものとみなされます。',
  terms_s1_p2: '当社はいつでも本規約を変更する権利を留保します。変更後の規約はウェブサイトに掲載され、継続的な利用は変更後の規約への同意を意味します。',
  terms_s2_title: '製品と購入',
  terms_s2_p1: '本ウェブサイトを通じて製品を購入する際は、以下を遵守する必要があります：',
  terms_s2_li1: '提供するすべての情報は真実、正確、かつ完全でなければなりません',
  terms_s2_li2: '18歳以上であるか、保護者の同意を得て本サービスを利用する必要があります',
  terms_s2_li3: '製品価格は予告なく変更される場合があり、注文時に表示された価格が適用されます',
  terms_s3_title: '配送と納品',
  terms_s3_p1: '当社は約束された時間内に製品を配送するよう最善を尽くしますが、実際の配送時間は物流状況により異なる場合があります。',
  terms_s3_p2: '配送範囲、送料、到着予定時間はチェックアウトページに表示される内容に従います。不可抗力による遅延が発生した場合は、速やかにお知らせします。',
  terms_s4_title: '返品・交換ポリシー',
  terms_s4_p1: '当社は優れたアフターサービスの提供に努めています。返品・交換ポリシーは以下の通りです：',
  terms_s4_li1: '製品受領後7日以内に品質問題がある場合、返品または交換を申請できます',
  terms_s4_li2: '製品は元の包装のままで、未使用かつ破損がないこと',
  terms_s4_li3: '返品送料は責任のある側が負担します。品質問題の場合は当社が送料を負担します',
  terms_s5_title: '知的財産権',
  terms_s5_p1: '本ウェブサイト上のすべてのコンテンツ（テキスト、画像、ロゴ、製品デザインなどを含むがこれらに限定されない）は、知的財産法により保護され、Koorpetに帰属します。',
  terms_s5_p2: '当社の書面による許可なく、本ウェブサイトのコンテンツを複製、改変、配布、またはいかなる方法でも使用することはできません。',
  terms_s6_title: '免責事項',
  terms_s6_p1: '本ウェブサイトの内容は参考情報としてのみ提供されます。当社は、本ウェブサイトの利用またはその情報への依存から生じる直接的または間接的な損失について責任を負いません。製品画像は参考用であり、実際に受け取る製品が優先されます。',
  terms_s7_title: '準拠法',
  terms_s7_p1: '本利用規約は中華人民共和国の法律に準拠します。紛争が発生した場合、両当事者はまず協議による解決を試みます。協議が不調の場合、香港特別行政区の管轄裁判所に付託されます。',
  terms_s8_title: 'お問い合わせ',
  terms_s8_p1: '本利用規約についてご質問がある場合は、以下までお問い合わせください：',
};

export default ja;